<template>
	<div class="loan-eligibility-calculator">
		<b-card no-body class="p-3" v-loading="is_loading">
			<b-row>
				<b-col cols="12">
					<b-row align-v="center" align-h="between" class="mb-2">
						<b-col class="d-flex align-items-center">
							<h3 class="mb-0">Credit Loan Application</h3>
							<span class="mx-2 py-0 text-primary text-xs" style="cursor: pointer;"
								@click="viewLoanTable">
								View Loan Table
								<b-icon icon="chevron-right"></b-icon>
							</span>
						</b-col>
					</b-row>
					<div class="card-table-simple">
						<b-table-simple responsive bordered>
							<b-tbody>
								<b-tr>
									<b-th width="50%">Loan Amount</b-th>
									<b-td class="bg-warning">
										<CurrencyInput v-model="formData.loan_amount" :disabled="isViewOnly"
											@blur="changeLoan(false)"
											:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
									</b-td>
								</b-tr>
								<b-tr>
									<b-th>Interest Rate</b-th>
									<b-td class="bg-warning">
										<b-form-input v-model="formData.interest_rate" :disabled="isViewOnly"
											@blur="changeLoan(false)" @keydown="_gHlp.checkNonNumericInput"></b-form-input>
									</b-td>
								</b-tr>
								<b-tr>
									<b-th>Loan Installment</b-th>
									<b-td>
										<CurrencyInput v-model="formData.installment_amount" :disabled="true"
											:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
									</b-td>
								</b-tr>
								<b-tr>
									<b-th>Loan Tenure ({{ formData.loan_tenure_period }})</b-th>
									<b-td>
										<b-form-input v-model="formData.loan_tenure" @keydown="_gHlp.checkNonNumericInput"
											disabled></b-form-input>
									</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</div>
				</b-col>

				<b-col cols="12">
					<div class="d-flex align-items-center my-2">
						<div>
							<el-switch style="display: block" v-model="formData.moratorium_eligible"
								active-color="#099A78" :active-value="1" :inactive-value="0" @change="changeLoan(false)"
								:disabled="isViewOnly">
							</el-switch>
						</div>
						<div class="ml-2">
							<strong>Moratorium Eligible</strong>
						</div>
					</div>
					<b-row v-if="formData.moratorium_eligible == 1" class="my-3">
						<b-col cols="12">
							<div class="card-table-simple">
								<b-table-simple bordered responsive>
									<b-tbody>
										<b-tr>
											<b-th width="50%">Moratorium Eligible (%)</b-th>
											<b-td class="bg-warning">
												<b-form-input v-model="formData.moratorium_eligible_rate"
													@keydown="_gHlp.checkNonNumericInput" :disabled="isViewOnly"
													@blur="changeLoan(false)"></b-form-input>
											</b-td>
										</b-tr>
										<b-tr>
											<b-th>Moratorium Instalment</b-th>
											<b-td>
												<CurrencyInput v-model="formData.moratorium_installment"
													:disabled="true"
													:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
											</b-td>
										</b-tr>
										<b-tr>
											<b-th>Moratorium Tenure ({{ formData.moratorium_tenure_period }})</b-th>
											<b-td class="bg-warning">
												<b-form-input v-model="formData.moratorium_tenure"
													@keydown="_gHlp.checkNonNumericInput" :disabled="isViewOnly"
													@blur="changeLoan(false)"></b-form-input>
											</b-td>
										</b-tr>
									</b-tbody>
								</b-table-simple>
							</div>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="12">
					<div class="d-flex align-items-center my-2">
						<div>
							<el-switch style="display: block" v-model="formData.flexi_loan_eligible"
								active-color="#099A78" :active-value="1" :inactive-value="0" @change="changeLoan(false)"
								:disabled="isViewOnly">
							</el-switch>
						</div>
						<div class="ml-2">
							<strong>Flexi Loan Eligible</strong>
						</div>
					</div>

					<b-row v-if="formData.flexi_loan_eligible == 1" class="my-3">
						<b-col cols="12">
							<div class="d-flex align-items-center">
								<h3 class="mb-0">Flexi Credit Loan Details</h3>
								<span class="mx-2 py-0 text-primary text-xs" style="cursor: pointer;"
									@click="viewFlexiLoanTable">
									View Loan Table
									<b-icon icon="chevron-right"></b-icon>
								</span>
							</div>
						</b-col>
						<b-col cols="12">
							<div class="card-table-simple">
								<b-table-simple responsive bordered>
									<b-tbody>
										<b-tr>
											<b-th width="50%">Eligible Limit</b-th>
											<b-td :class="{ 'text-red': formData.flexi_eligible_limit < 0 }">
												RM {{ formData.flexi_eligible_limit | moneyFormatter }}
											</b-td>
										</b-tr>
										<b-tr>
											<b-th>Flexi Loan Amount</b-th>
											<b-td class="bg-warning">
												<CurrencyInput v-model="formData.flexi_loan_amount"
													:disabled="isViewOnly" @blur="changeLoan(false)"
													:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
											</b-td>
										</b-tr>
										<b-tr>
											<b-th>Interest Rate (%)</b-th>
											<b-td class="bg-warning">
												<b-form-input v-model="formData.flexi_interest_rate"
													:disabled="isViewOnly" @blur="changeLoan(false)"
													@keydown="_gHlp.checkNonNumericInput"></b-form-input>
											</b-td>
										</b-tr>
										<b-tr>
											<b-th>Loan Tenure (Months)</b-th>
											<b-td>{{ formData.flexi_loan_tenure }}</b-td>
										</b-tr>
									</b-tbody>
								</b-table-simple>
							</div>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
			<div class="text-right p-2" v-if="!isViewOnly">
				<el-button type="warning" class="mx-1" size="mini" @click="submitAndCalculate"
					icon="el-icon-circle-check">Save
					& Calculate</el-button>
			</div>
		</b-card>

		<!-- Modal View  -->
		<modal :show.sync="modals.view_loan_table" size="lg" modalClass="modal_view_loan_table">
			<h6 slot="header" class="modal-title">
				Rule 78 Loan Table ({{ formData.selectedLoanType ? formData.selectedLoanType.name : '' }} {{
			formData.moratorium_eligible == 1 ? '- Moratorium' : '' }})
			</h6>
			<div class="table-simple">
				<b-table-simple bordered responsive>
					<b-thead>
						<b-tr>
							<b-th class="text-white">Loan Amount</b-th>
							<b-th class="text-white">Interest Rate</b-th>
							<b-th class="text-white">Loan Tenure</b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<b-tr>
							<b-td>RM {{ formData.loan_amount | moneyFormatter }}</b-td>
							<b-td>{{ formData.interest_rate }}%</b-td>
							<b-td>{{ formData.loan_tenure + ' ' + formData.loan_tenure_period }}</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>
			<TableLoan :loan-table.sync="formData.loanTableList" />
			<div slot="footer"></div>
		</modal>

		<modal :show.sync="modals.view_flexi_loan_table" size="lg" modalClass="modal_view_flexi_loan_table">
			<h6 slot="header" class="modal-title">Rule Flexi Loan Table</h6>
			<div class="table-simple">
				<b-table-simple bordered responsive>
					<b-thead>
						<b-tr>
							<b-th class="text-white">Flexi Loan Amount</b-th>
							<b-th class="text-white">Interest Rate</b-th>
							<b-th class="text-white">Loan Tenure</b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<b-tr>
							<b-td>RM {{ formData.flexi_loan_amount | moneyFormatter }}</b-td>
							<b-td>{{ formData.flexi_interest_rate }}%</b-td>
							<b-td>{{ formData.flexi_loan_tenure + ' Months' }}</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>
			<TableLoan :loan-table.sync="formData.flexiLoanTableList" />
			<div slot="footer"></div>
		</modal>
	</div>
</template>
<script>
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import { cloneDeep } from 'lodash'
import { Select, Option, Button, Switch } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import TableLoan from '@/views/CustomerProfile/CenterComponents/LoanEligible/Cards/TableLoan'
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useCommonStore } from '@/stores/commonStore';

export default {
	components: {
		CurrencyInput,
		TableLoan,
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button,
		[Switch.name]: Switch,
	},
	props: [
		'is-view-only',
	],
	data() {
		return {
			formData: {
				loan_amount: 0,
				interest_rate: 0,
				loan_tenure_period: 'Years',
				loan_tenure: 0,
				tenure_period: '',
				moratorium_eligible: 0,
				moratorium_eligible_rate: 0,
				moratorium_installment: 0,
				moratorium_tenure: 0,
				flexi_loan_eligible: 0,
				flexi_loan_amount: 0,
				flexi_interest_rate: 0,
				flexi_eligible_limit: 0,
				flexi_loan_tenure: 0,
				selectedLoanType: {},
				loanTableList: [],
				flexiLoanTableList: []
			},
			modals: {
				view_loan_table: false,
				view_flexi_loan_table: false,
				view_dept_consolidation: false,
			},
		}
	},
	created() {
	},
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
	computed: {
		...mapState(useCommonStore, ['loanTypes']),
		...mapState(useCustomerStore, ['activeFormLoanEc']),
		is_loading() {
			return _gHlp.isLoading('fetch_loan_type') || _gHlp.isLoading('calc_loan_eligible') || _gHlp.isLoading('calc_loan_calculator') || _gHlp.isLoading('fetch_loan_ec')
		}
	},
	watch: {
		activeFormLoanEc: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					// console.log("CHANGE LOAN CALCULATOR");
					// console.log(newVal);
					this.formData = { ...this.formData, ...newVal }
				}
			},
			immediate: true
		},
	},
	methods: {
		...mapActions(useCustomerStore, ['updateLoanEC', 'setFormLoanEc']),
		clearComponent(){
			this.formData = {
				loan_amount: 0,
				interest_rate: 0,
				loan_tenure_period: 'Years',
				loan_tenure: 0,
				tenure_period: '',
				moratorium_eligible: 0,
				moratorium_eligible_rate: 0,
				moratorium_installment: 0,
				moratorium_tenure: 0,
				flexi_loan_eligible: 0,
				flexi_loan_amount: 0,
				flexi_interest_rate: 0,
				flexi_eligible_limit: 0,
				flexi_loan_tenure: 0,
				selectedLoanType: {},
				loanTableList: [],
				flexiLoanTableList: []
			}
			this.modals = {
				view_loan_table: false,
				view_flexi_loan_table: false,
				view_dept_consolidation: false,
			}
		},
		populateExistingFields() {
			this.onChangeLoanType(this.loanType?.id, true);
		},
		viewLoanTable() {
			this.modals.view_loan_table = !this.modals.view_loan_table
		},
		viewFlexiLoanTable() {
			this.modals.view_flexi_loan_table = !this.modals.view_flexi_loan_table
		},
		changeLoan(with_save = false) {
			this.setFormLoanEc(this.formData)
			this.$emit('change', with_save);
		},
		submitAndCalculate() {
			this.changeLoan(true)
		}
	}
}
</script>